import { render } from "./UploadProgress.vue?vue&type=template&id=9795f974"
import script from "./UploadProgress.vue?vue&type=script&lang=js"
export * from "./UploadProgress.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__